/**
 * 卖家须知 API(发布守卫链第 4 层)。两端点均需 KYC_VERIFIED。
 *   GET  /api/v1/marketing/seller-notices/status  → { required, currentVersion, ... }
 *   POST /api/v1/marketing/seller-notices/accept   → { sellerNoticeVersionAccepted, ... }
 * 生成类型为 envelope 包装,此处本地声明内层 payload。
 */
import { call } from './client';

export interface SellerNoticeStatus {
  required: boolean;
  currentVersion?: string;
  acceptedVersion?: string | null;
  acceptedAt?: string | null;
}

export interface SellerNoticeAccept {
  sellerNoticeVersionAccepted: string;
  sellerNoticeAcceptedAt: string;
}

export function getSellerNoticeStatus(): Promise<SellerNoticeStatus> {
  return call<SellerNoticeStatus>({ method: 'GET', url: '/api/v1/marketing/seller-notices/status' });
}

export function acceptSellerNotice(): Promise<SellerNoticeAccept> {
  return call<SellerNoticeAccept>({ method: 'POST', url: '/api/v1/marketing/seller-notices/accept' });
}
